import React from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { Box, DetailedBanner } from '@qga/roo-ui/components';
import { iconFoodWine } from '@qga/roo-ui/assets';
import { useDataLayer } from 'hooks/useDataLayer';
import { getPropertyId } from 'store/property/propertySelectors';
import { getQueryParams } from 'store/router/routerSelectors';

const ExclusiveOfferCrossSellBanner = () => {
  const { emitInteractionEvent } = useDataLayer();
  const propertyId = useSelector(getPropertyId);

  const queryParams = useSelector(getQueryParams);
  const router = useRouter();

  const bannerIcon = { src: iconFoodWine, alt: 'Food & wine logo' };
  const bannerCta = { label: 'View Exclusive Offers', type: 'text', iconName: 'arrowForward' };
  const exclusiveOffersUrl = `/properties/${propertyId}/exclusive-offers`;

  const handleBannerClick = () => {
    emitInteractionEvent({ type: 'Exclusive Offers Cross Sell Banner', value: 'View Exclusive Offers Selected' });
    router.push({
      pathname: exclusiveOffersUrl,
      query: queryParams,
    });
  };

  return (
    <Box
      backgroundColor="white"
      mb={[4, 0]}
      boxShadow="hard"
      borderRadius={'default'}
      css={{ cursor: 'pointer' }}
      data-testid="exclusive-offer-banner"
    >
      <DetailedBanner
        icon={bannerIcon}
        heading="Want to treat yourself with extra special inclusions & great savings?"
        cta={bannerCta}
        layout="row"
        onClick={handleBannerClick}
        boxShadow="none"
      >
        <Box>There are limited time special offers available for this hotel for specific dates or nights stay.</Box>
      </DetailedBanner>
    </Box>
  );
};

export default ExclusiveOfferCrossSellBanner;
